const FontBase = 16;
const NavBarHeight = 60;
const NavBarHeightMobile = 60;
const SubNavBarHeight = 72;
const SubNavBarHeightMobile = 72;
const BackButtonHeight = 32;
const FooterHeight = 300;
const SubFooterHeight = 72;
const FooterHeightMobile = 170;

const ENV_PORTAL_REDIRECT = {
  DEV: null,
  SIT: null,
  PRE_PROD: null,
  PROD: 'https://portale.banca5.com',

  DEFAULT: 'https://portale.collaudo.banca5.com:2443',
};

const ENV_BO_REDIRECT = {
  DEV: 'https://devb5.ispfdevelop.com/',
  SIT: 'https://apisitb5.ispfdevelop.com/',
  PRE_PROD: 'https://apidemob5.ispfdevelop.com/',
  PROD: 'https://apielearning.banca5.com/',

  DEFAULT: 'https://apielearning.banca5.com/',
};

const PortalHomepage =
  ENV_PORTAL_REDIRECT[process.env.REACT_APP_DEPLOY_ENV] ||
  ENV_PORTAL_REDIRECT.DEFAULT;
const BOHomepage =
  ENV_BO_REDIRECT[process.env.REACT_APP_DEPLOY_ENV] || ENV_BO_REDIRECT.DEFAULT;

export {
  PortalHomepage,
  BOHomepage,
  FontBase,
  NavBarHeight,
  NavBarHeightMobile,
  SubNavBarHeight,
  SubNavBarHeightMobile,
  BackButtonHeight,
  FooterHeight,
  SubFooterHeight,
  FooterHeightMobile,
};
